<fieldset
    [formGroup]="radioGroup"
    class="d-flex"
    [ngClass]="{
        'flex-column flex-md-row': useResponsiveLayout,
        'readonly-input-control': isReadonlyInputControl,
    }"
    paceCoreValidationMessage
    [validation]="radioGroup"
>
    <span
        *ngFor="let entry of model.value"
        class="d-flex align-items-center me-3 ps-0"
        [ngClass]="useResponsiveLayout ? 'my-2 my-md-0' : ''"
    >
        <input
            type="radio"
            class="form-check-input"
            [value]="entry"
            [checked]="entry.displayName === model.selectedEntry?.displayName"
            formControlName="radioControl"
            [attr.aria-label]="entry.displayName"
        />
        <label class="ms-2"> {{ entry.displayName }} </label>
    </span>
</fieldset>
